import { pageLocale } from "./locale";
import { getTugCategoryConfig } from "./metricsConfig";

const {
  tug,
  tug_time,
  gait,
  summary,
  speed,
  step_length,
  steps_per_minute,
  balance,
  head_wobbling,
  shoulder_balance,
  hip_balance,
  sit_to_standup_time,
  attempts_to_rise,
  s,
  steps_min,
  degree,
  stand_to_sit_time,
  right_left_step_symmetry,
  gait_smoothness,
  foot_clearance,
  trunk_sway,
  stability,
  turning,
  turning_time,
  steps_during_turn,
  joints,
  joint_angles_knee,
  joint_angles_hip,
  cm_s,
  cm,
  foot_placement,
  postural_control,
} = pageLocale("newreport");

const mv2Metrics = pageLocale("metricsv2_metrics") || {};
const mv2Categories = pageLocale("metricsv2_categories") || {};

const right_left_step_symmetry_label =
  mv2Metrics.Right_Left_Step_Symmetry ||
  right_left_step_symmetry ||
  "Step Symmetry";
const power_label = mv2Categories.power || "Power";
const control_label = mv2Categories.control || "Control";
const change_velocity_label = mv2Metrics.Change_Velocity || "Change Velocity";
const lateral_latency_label = mv2Metrics.Lateral_Latency || "Lateral Latency";
const rise_velocity_label = mv2Metrics.Rise_Velocity || "Rise Velocity";
const joint_excursion_label = mv2Metrics.Joint_Excursion || "Joint Excursion";

const frontTugMainOption = [
  {
    text: tug,
    value: "tug",
    subOptions: [
      {
        text: tug_time,
        value: "time",
        unit: s,
        graphReference: "fronttugTime",
        chartType: "lollipop",
      },
    ],
  },
  {
    text: gait,
    value: "gait",
    subOptions: [
      {
        text: summary,
        value: "summary",
        unit: "",
        graphReference: "frontgaitSummary",
        chartType: "lollipop",
      },
      {
        text: speed,
        value: "speed",
        unit: "(cm/s)",
        graphReference: "frontgaitSpeed",
        chartType: "lollipop",
      },
      {
        text: step_length,
        value: "stepLength",
        unit: "(cm)",
        graphReference: "frontgaitStepLength",
        chartType: "lollipop",
      },
      {
        text: steps_per_minute,
        value: "cadence",
        unit: `(${steps_min})`,
        graphReference: "frontgaitStepPerMinute",
        chartType: "lollipop",
      },
      {
        text: right_left_step_symmetry_label,
        value: "rightLeftStepSymmetry",
        unit: "",
        graphReference: "rightLeftStepSymmetry",
        chartType: "lollipop",
      },
      {
        text: foot_placement,
        value: "footPlacement",
        unit: "(cm)",
        graphReference: "footPlacement",
        chartType: "lollipop",
      },
    ],
  },
  {
    text: balance,
    value: "balance",
    subOptions: [
      {
        text: summary,
        value: "summary",
        unit: "",
        graphReference: "frontBalancesummary",
        chartType: "lollipop",
      },
      {
        text: sit_to_standup_time,
        value: "sitToStandTime",
        unit: s,
        graphReference: "sitToStandTime",
        chartType: "lollipop",
      },
      {
        text: stand_to_sit_time,
        value: "standToSitTime",
        unit: s,
        graphReference: "standToSitTime",
        chartType: "lollipop",
      },
      {
        text: attempts_to_rise,
        value: "attemptsToRise",
        unit: "",
        graphReference: "attemptsToRise",
        chartType: "lollipop",
      },
    ],
  },
  {
    text: stability,
    value: "stability",
    subOptions: [
      {
        text: head_wobbling,
        type: "balance",
        value: "headWobbling",
        unit: "(cm)",
        graphReference: "frontbalanceHeadWobbling",
        chartType: "lollipop",
      },
      {
        text: shoulder_balance,
        type: "balance",
        value: "shoulderBalanceLRdeg",
        unit: `(${degree})`,
        graphReference: "frontShoulderBalance",
        chartType: "lollipop",
      },
      {
        text: hip_balance,
        type: "balance",
        value: "hipBalanceLRdeg",
        unit: `(${degree})`,
        graphReference: "frontHipBalance",
        chartType: "lollipop",
      },
      {
        text: trunk_sway,
        value: "trunkSway",
        unit: `(${degree})`,
        graphReference: "trunkSway",
        chartType: "lollipop",
      },
      {
        text: postural_control,
        value: "posturalControl",
        unit: "",
        graphReference: "posturalControl",
        chartType: "lollipop",
      },
    ],
  },
  {
    text: turning,
    value: "turning",
    subOptions: [
      {
        text: turning_time,
        value: "turningTime",
        unit: s,
        graphReference: "turningTime",
        chartType: "lollipop",
      },
      {
        text: steps_during_turn,
        value: "stepsDuringTurn",
        unit: "",
        graphReference: "stepsDuringTurn",
        chartType: "lollipop",
      },
    ],
  },
  {
    text: power_label,
    value: "power",
    subOptions: [
      {
        text: change_velocity_label,
        value: "changeVelocity",
        unit: "",
        graphReference: "changeVelocity",
        chartType: "lollipop",
      },
      {
        text: lateral_latency_label,
        value: "lateralLatency",
        unit: "",
        graphReference: "lateralLatency",
        chartType: "lollipop",
      },
    ],
  },
];

const sideTugMainOption = [
  {
    text: tug,
    value: "tug",
    subOptions: [
      {
        text: tug_time,
        value: "time",
        unit: s,
        graphReference: "fronttugTime",
        chartType: "lollipop",
      },
    ],
  },
  {
    text: gait,
    value: "gait",
    subOptions: [
      {
        text: speed,
        value: "speed",
        unit: cm_s,
        graphReference: "frontgaitSpeed",
        chartType: "lollipop",
      },
      {
        text: step_length,
        value: "stepLength",
        unit: cm,
        graphReference: "frontgaitStepLength",
        chartType: "lollipop",
      },
      {
        text: steps_per_minute,
        value: "cadence",
        unit: `(${steps_min})`,
        graphReference: "frontgaitStepPerMinute",
        chartType: "lollipop",
      },
      {
        text: right_left_step_symmetry,
        value: "rightLeftStepSymmetry",
        unit: "",
        graphReference: "rightLeftStepSymmetry",
        chartType: "lollipop",
      },
      {
        text: gait_smoothness,
        value: "gaitSmoothness",
        unit: "",
        graphReference: "gaitSmoothness",
        chartType: "lollipop",
      },
      {
        text: foot_clearance,
        value: "footClearance",
        unit: cm,
        graphReference: "footClearance",
        chartType: "lollipop",
      },
    ],
  },
  {
    text: balance,
    value: "balance",
    subOptions: [
      {
        text: sit_to_standup_time,
        value: "sitToStandTime",
        unit: s,
        graphReference: "timeToStandUp",
        chartType: "lollipop",
      },
      {
        text: stand_to_sit_time,
        value: "standToSitTime",
        unit: s,
        graphReference: "standToSitTime",
        chartType: "lollipop",
      },
      {
        text: attempts_to_rise,
        value: "attemptsToRise",
        unit: "",
        graphReference: "attemptsToRise",
        chartType: "lollipop",
      },
    ],
  },
  {
    text: stability,
    value: "stability",
    subOptions: [
      {
        text: trunk_sway,
        value: "trunkSway",
        unit: "",
        graphReference: "trunkSway",
        chartType: "lollipop",
      },
    ],
  },
  {
    text: turning,
    value: "turning",
    subOptions: [
      {
        text: turning_time,
        value: "turningTime",
        unit: s,
        graphReference: "turningTime",
        chartType: "lollipop",
      },
      {
        text: steps_during_turn,
        value: "stepsDuringTurn",
        unit: "",
        graphReference: "stepsDuringTurn",
        chartType: "lollipop",
      },
    ],
  },
  {
    text: joints,
    value: "joints",
    subOptions: [
      {
        text: joint_angles_knee,
        value: "jointAnglesKnee",
        unit: `(${degree})`,
        graphReference: "frontgaitStepLength",
        chartType: "lollipop",
      },
      {
        text: joint_angles_hip,
        value: "jointAnglesHip",
        unit: `(${degree})`,
        graphReference: "frontgaitStepLength",
        chartType: "lollipop",
      },
    ],
  },
  {
    text: power_label,
    value: "power",
    subOptions: [
      {
        text: change_velocity_label,
        value: "changeVelocity",
        unit: "",
        graphReference: "changeVelocity",
        chartType: "lollipop",
      },
    ],
  },
  {
    text: control_label,
    value: "control",
    subOptions: [
      {
        text: rise_velocity_label,
        value: "riseVelocity",
        unit: "",
        graphReference: "riseVelocity",
        chartType: "lollipop",
      },
      {
        text: joint_excursion_label,
        value: "jointExcursion",
        unit: "",
        graphReference: "jointExcursion",
        chartType: "lollipop",
      },
    ],
  },
];
/**
 * Returns history dropdown options derived from getTugCategoryConfig so the
 * history view always shows the same metrics as the summary view.
 */
export const getTugHistoryOptions = (reportType) => {
  const mv2Categories = pageLocale("metricsv2_categories") || {};
  const mv2Metrics = pageLocale("metricsv2_metrics") || {};
  const mv2Units = pageLocale("metricsv2_units") || {};

  return getTugCategoryConfig(reportType).map((cat) => ({
    text: mv2Categories[cat.key] || cat.key.replace(/_/g, " "),
    value: cat.summaryKey,
    subOptions: cat.metrics.map((m) => ({
      text: mv2Metrics[m.metric] || m.metric.replace(/_/g, " "),
      value: m.apiField,
      type: m.category,
      unit: mv2Units[m.metric] || m.unit || "",
      graphReference: m.graphReference || "",
      chartType: "lollipop",
    })),
  }));
};

export { frontTugMainOption, sideTugMainOption };
